// Typelizer digest fb9faf328e352f517ea09fa9a7e4d71d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** PATCH /fields/:field_id/days/:date */
  update: (
    params: { fieldId: string | number; date: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/fields/:field_id/days/:date', params, options),
    method: 'patch',
  }),
}
